import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'saf-open-info',
    templateUrl: './open-info.component.html',
    styleUrls: ['./open-info.component.scss'],
    standalone: false
})
export class OpenInfoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
